/* eslint-disable new-cap */
import AOS from 'aos'
import 'aos/dist/aos.css'
export default ({ app }) => {
  app.AOS = new AOS.init({
    once: true,
    disable: window.innerWidth < 768,
  })
}
